export const SET_CHRISTMAS_GIFT = 'SET_CHRISTMAS_GIFT';